import {isWorkflowCreateTaskFormsEnabled} from 'forms/FormsPermissions';
import LocalStorage from 'LocalStorage';
import {
  TableOrFormRenderOptions,
  TableOrFormRenderOptionsType,
} from 'notebook/structured-tables/StructuredTableOrFormOutsideNotebook';
import {ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';
import EntityStore from 'stores/EntityStore';

export type CreateTaskModalViewPreference = [
  viewMode: TableOrFormRenderOptionsType,
  formId: string | undefined,
];

const LOCAL_STORAGE_BASE_KEY = 'CREATE_TASK_MODAL_VIEW_PREFERENCE';

function makeCreateTaskModalViewLocalStorageKey(taskSchemaId: string): string {
  const userId = EntityStore.currentUserId;
  return `${LOCAL_STORAGE_BASE_KEY}-${userId}-${taskSchemaId}`;
}

export function saveCreateTaskModalViewPreference(
  taskSchemaId: string,
  preference: CreateTaskModalViewPreference
): void {
  LocalStorage.json.setItem(makeCreateTaskModalViewLocalStorageKey(taskSchemaId), preference);
}

export function getCreateTaskModalViewPreference(
  taskSchemaId: string
): CreateTaskModalViewPreference | undefined {
  return LocalStorage.json.getItem(makeCreateTaskModalViewLocalStorageKey(taskSchemaId));
}

/** Based on the config flag and the current Process Task (if available) determine which view to show by default */
export function getInitialCreateTaskModalViewPreference(
  schemaId: string,
  taskTable?: ProcessTaskStructuredTable
): CreateTaskModalViewPreference {
  if (!isWorkflowCreateTaskFormsEnabled()) {
    return [TableOrFormRenderOptions.TABLE, undefined];
  }
  const savedPreference = getCreateTaskModalViewPreference(schemaId) ?? [
    TableOrFormRenderOptions.FORM,
    undefined,
  ];
  if (taskTable && taskTable.rows.length > 1) {
    const [, savedFormId] = savedPreference;
    return [TableOrFormRenderOptions.TABLE, savedFormId];
  }
  return savedPreference;
}
